import React from 'react';
import '../../../services/ConsoleHelper.js';
import BackgroundVideo from '../components/BackgroundVideo';
import SignupForm from '../components/SignupForm';

const SignupScreen = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-[1000]">
      <BackgroundVideo />
      
      <div className="absolute top-0 left-0 w-full h-full bg-black/50 flex justify-center items-center">
        <div className="w-full max-w-md px-4 animate-fadeIn">
          <SignupForm />
        </div>
      </div>
    </div>
  );
};

export default SignupScreen;